import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import * as storySanityApi from 'api/sanity/story';
import { getI18n } from 'react-i18next';
import { AppThunk } from 'store';

function toStory(sanityStory: SanityStory): Story {
  const lang = getI18n().language as Language;
  return {
    title: sanityStory.title?.textContent[lang] ? sanityStory.title?.textContent[lang] : sanityStory.title?.textContent['en'],
    videoUrl: sanityStory.videoUrl,
    alt: sanityStory.mainImage.alt,
    previewUrl: sanityStory.mainImage.asset?.url ?? '',
  };
}

interface State {
  loading: boolean;
  items: Story[];
}

const initialState: State = {
  loading: false,
  items: [],
};

const slice = createSlice({
  name: 'stories',
  initialState,
  reducers: {
    setLoading: (state: State, action: PayloadAction<boolean>): State => {
      state.loading = action.payload;
      return state;
    },
    setStories: (state: State, action: PayloadAction<Story[]>): State => {
      state.items = action.payload;
      return state;
    },
  },
});

const { setLoading, setStories } = slice.actions;

export default slice.reducer;

export const loadStories = (): AppThunk => async (dispatch): Promise<void> => {
  dispatch(setLoading(true));
  try {
    const data = await storySanityApi.getAll();
    const stories = data.map(toStory);
    dispatch(setStories(stories));
    dispatch(setLoading(false));
  } catch {
    dispatch(setLoading(false));
  }
};
